import "./App.scss";

import Sidebar from "./components/Sidebar";

import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import AboutUs from "./pages/AboutUs";
import { useState } from "react";
import { Menu } from "lucide-react";
import Home from "./pages/Home";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsAndCondition from "./pages/TermsAndCondition";


function App() {
  const [sidebarOpen, setSidebarOpen] = useState(false);






  return (
    <Routes>
    <Route path="/" element={<Home />} />  
    <Route path="/about-us" element={<AboutUs />} />
    <Route path="/privacy-policies" element={<PrivacyPolicy />} />
    <Route path="/terms-and-condition" element={<TermsAndCondition />} />
    </Routes>

   
  );
}

export default App;
